var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormFieldsContainer",
    [
      _c(
        "v-flex",
        { attrs: { md3: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|numeric",
                expression: "'required|numeric'"
              }
            ],
            attrs: {
              label: _vm.formFields.txtMinimoDias.label,
              "error-messages": _vm.errors.collect("numSim"),
              "data-vv-name": "numSim",
              required: ""
            },
            on: { change: _vm.ResumenTiempoTxtMinimoDetencion },
            model: {
              value: _vm.formFields.txtMinimoDias.value,
              callback: function($$v) {
                _vm.$set(_vm.formFields.txtMinimoDias, "value", $$v)
              },
              expression: "formFields.txtMinimoDias.value"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { md2: "" } },
        [
          _c("TimePicker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              label: _vm.formFields.horaInicio.label,
              "error-messages": _vm.errors.collect(
                _vm.formFields.horaInicio.id
              ),
              id: _vm.formFields.horaInicio.id,
              disabled: false
            },
            model: {
              value: _vm.formFields.horaInicio.value,
              callback: function($$v) {
                _vm.$set(_vm.formFields.horaInicio, "value", $$v)
              },
              expression: "formFields.horaInicio.value"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }